/* eslint-disable react/no-unknown-property */
/* eslint-disable max-len */
import React from 'react';

/**
 * ModalSuccessIcon - Auto-generated from icon.js
 */
export const ModalSuccessIcon = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
	<svg width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<g clipPath="url(#clip0_3860_6230)">
			<path fillRule="evenodd" clipRule="evenodd" d="M16.5 1.90735e-06C7.66325 1.90735e-06 0.5 7.16325 0.5 16C0.5 24.8368 7.66325 32 16.5 32C25.3368 32 32.5 24.8368 32.5 16C32.5 7.16325 25.3368 1.90735e-06 16.5 1.90735e-06ZM26.1729 11.7564L13.179 24.4032C12.7879 24.7942 12.1529 24.7942 11.7619 24.4032L6.79772 19.6579C6.40671 19.2669 6.40671 18.6319 6.79772 18.2409C7.18873 17.8499 7.82372 17.8499 8.21473 18.2409L12.472 22.2792L24.7559 10.3394C25.1469 9.94843 25.7819 9.94843 26.1729 10.3394C26.5639 10.7304 26.5639 11.3654 26.1729 11.7564Z" fill="#78C90F" />
		</g>
		<defs>
			<clipPath id="clip0_3860_6230">
				<rect width="32" height="32" fill="white" transform="translate(0.5)" />
			</clipPath>
		</defs>
	</svg>
);

export default ModalSuccessIcon;
